import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import * as carAssignmentResolvers from './by-state';

function CarAssignment({ state, disabled }) {
  const CarAssignmentByState = useMemo(() => carAssignmentResolvers[`carAssignment${state.toUpperCase()}`], [state]);

  return <CarAssignmentByState disabled={disabled} />;
}

CarAssignment.propTypes = {
  disabled: PropTypes.bool,
  state: PropTypes.string.isRequired
};

CarAssignment.defaultProps = {
  disabled: false
};

export default CarAssignment;
